module.exports = __webpack_public_path__ + "static/media/scroll3_1.d5360ec5.png";